var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputTypeNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72184 0.503041C4.99629 0.533536 5.19406 0.780745 5.16356 1.0552L4.78081 4.49998H7.77465L8.16968 0.944767C8.20017 0.670314 8.44738 0.472546 8.72184 0.503041C8.99629 0.533536 9.19406 0.780745 9.16356 1.0552L8.78081 4.49998H11.3333C11.6095 4.49998 11.8333 4.72384 11.8333 4.99998C11.8333 5.27612 11.6095 5.49998 11.3333 5.49998H8.6697L8.33636 8.49998H11.3333C11.6095 8.49998 11.8333 8.72384 11.8333 8.99998C11.8333 9.27612 11.6095 9.49998 11.3333 9.49998H8.22525L7.83023 13.0552C7.79973 13.3297 7.55252 13.5274 7.27807 13.4969C7.00362 13.4664 6.80585 13.2192 6.83634 12.9448L7.2191 9.49998H4.22525L3.83023 13.0552C3.79973 13.3297 3.55252 13.5274 3.27807 13.4969C3.00362 13.4664 2.80585 13.2192 2.83634 12.9448L3.2191 9.49998H0.666656C0.390514 9.49998 0.166656 9.27612 0.166656 8.99998C0.166656 8.72384 0.390514 8.49998 0.666656 8.49998H3.33021L3.66354 5.49998H0.666656C0.390514 5.49998 0.166656 5.27612 0.166656 4.99998C0.166656 4.72384 0.390514 4.49998 0.666656 4.49998H3.77465L4.16968 0.944767C4.20017 0.670314 4.44738 0.472546 4.72184 0.503041ZM7.33021 8.49998L7.66354 5.49998H4.6697L4.33636 8.49998H7.33021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputTypeNumber);
export default __webpack_public_path__ + "static/media/input_type_number.585b6e08ea4475ada095bd7a63e75fb5.svg";
export { ForwardRef as ReactComponent };